module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ppp-differentpaths008htmlepigraph"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppdifferentpaths006#ppp-differentpaths006htmltoc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("We all of us have taken different paths now; but in")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("This the first great fragmentation of my maturity, I feel the confines of my")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Art and my living deepening immeasurably by the memory of them.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Lawrence Durrell, "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Justine")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a468d60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-differentpaths008.vue
// module id = 75
// module chunks = 0